'use client'

import type { FC, PropsWithChildren } from 'react'

export const NextImageStyles: FC<PropsWithChildren> = ({ children }) => {
	return (
		<>
			<style jsx global>{`
				img[data-nimg='fill'] {
					position: absolute;
					height: 100%;
					width: 100%;
					left: 0;
					top: 0;
					right: 0;
					bottom: 0;
					color: transparent;
				}
			`}</style>
			{children}
		</>
	)
}
